//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { Hub } from 'aws-amplify';

/**
 *
 * We can subscribe to AWS Amplify events by plugging them
 * in to the Hub.listen() function below. For more info, see
 * https://aws-amplify.github.io/docs/js/hub#authentication-events
 */
const authListener = (data) => {
  switch (data.payload.event) {
    case 'signOut':
      // Clear the client id cookie on logout
      document.cookie = 'crl8.clntid=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;';
      break;
  }
};

Hub.listen('auth', authListener);
